import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { ObjetoCatalogo } from '../../model/ObjetoCatalogo';
import { CarritoService } from './../../services/carrito.service';
import { ItemCarrito } from '../../model/ItemCarrito';

@Component({
  selector: 'app-carrito-popup',
  imports: [CommonModule, MatMenuModule, MatIconModule, RouterModule],
  templateUrl: './carrito-popup.component.html',
  styleUrl: './carrito-popup.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class CarritoPopupComponent implements OnInit {
  cantidad: number = 0;
  showPopup: boolean = false;
  showCantidad: boolean = false;
  item: ObjetoCatalogo | null = null;
  cantidadItem: number = 1;
  carrito: ItemCarrito[] = [];
  constructor(private router: Router, private service: CarritoService) {
  }

  ngOnInit(): void {
    this.service.$ultimoItem.subscribe(item => {
      this.item = item;
      if (item != null && !this.linkDisabled()) {
        this.showPopup = true;
        this.showCantidad = true;
      }
      else {
        this.showPopup = false;
      }
    });
    this.service.$totalItems.subscribe(cantidad => {
      this.cantidad = cantidad;
      if (cantidad === 0) {
        this.showCantidad = false;
        this.showPopup = false;
        this.item = null; 
      }
    });
    this.service.$carrito.subscribe(carrito => {
      this.carrito = carrito;
      let itemCarrito = carrito.find(x => x.id === this.item?.id);
      if (itemCarrito) this.cantidadItem = itemCarrito.cantidad;
    });
  }

  selectedImage(item: ObjetoCatalogo | null) {
    return item != null ? item.images[0].url : '';
  }

  public linkDisabled(): boolean {
    return this.router.url === '/carrito';
  }

  showCarritoPopUp(): boolean {
    return this.showPopup;
  }

  closePopup() {
    this.showPopup = false;
  }
}
